module.exports = __webpack_public_path__ + "img/boss_struct.41d80533.jpg";